import { BaseDocument } from '../BaseDocument';
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { IListForm } from '../../interfaces/ilist-form';
import { CrudOperations } from '../../interfaces/crudOperations';
import { State } from '../models/State';
import { MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';

export class ListForm<T extends BaseDocument> implements OnInit, IListForm<T>{
    /**
     *
     */
    routeRoot:string;
    protected dataService:CrudOperations<T>;
    protected router: Router;
    public states?:State[];
    public dataSource:MatTableDataSource<T> = null;
    constructor(dataService:CrudOperations<T>,routeRoot:string,router: Router,states?:State[]) {
        this.dataService = dataService;
        this.routeRoot = routeRoot;        
        this.router = router;
        this.states = states;
    }
    onLoad() {
        this.dataService.GetAll().subscribe(res => {          
          this.dataSource =  new MatTableDataSource(res.payload);        
        });
    }
    public onAdd() {
        this.router.navigate([`${this.routeRoot}/add`]);
    }
    public onEdit(item:T) {
        if(item && item.id){
            this.router.navigate([`${this.routeRoot}/edit`,item.id]);
        }
    }
    onRefresh() {
        this.onLoad();        
    }
    ngOnInit() {
        this.onLoad();
    }    
}